import "./styles.scss";

import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { MdKeyboardArrowRight } from "react-icons/md";

const HeaderClassesHeal = ({
  activeTab,
  onSubmitReport,
  handleNavigationNextStep,
  openShowModalCoordinator,
  handleButtonContentSpecific,
}) => {
  const { t } = useTranslation();
  const { report, nextContentsStudent, currentCycleAndLevelStudent } = useSelector((state) => state.methodologyReducer);

  const isCycleAndLeveEmpty = currentCycleAndLevelStudent.length === 0;
  const isNotDemo = report[0]?.classSchedule?.classScheduleDetails[0]?.focus !== "demo class";
  const isDisabled = nextContentsStudent.some((item) => item.focus?.toLowerCase() === "specific");

  const handleFinish = () => {
    openShowModalCoordinator();
    onSubmitReport();
  };

  return (
    <div className="header">
      <h2>{t("STUDENT_PERSONAL_PROFILE")}</h2>

      <div className="headerButtons">
        {activeTab === "CLASSES_HELD" && !isCycleAndLeveEmpty && (
          <>
            {isNotDemo && (
              <button
                disabled={isDisabled}
                onClick={handleButtonContentSpecific}
                className={`buttonClassSpecific ${isDisabled && "disabled"}`}
              >
                {t("ADD_SPECIFIC_CLASS")}
              </button>
            )}

            <button className="buttonNext" onClick={handleNavigationNextStep}>
              {t("BTN_NEXT")} <MdKeyboardArrowRight size={25} />
            </button>
          </>
        )}
        {activeTab === "CLASS_COMMENTARY" && !isCycleAndLeveEmpty && (
          <button type="button" className="buttonClassSpecific" onClick={handleFinish}>
            {t("BTN_NEXT")}
          </button>
        )}
      </div>
    </div>
  );
};

export default HeaderClassesHeal;
